import React, { useState } from 'react';
import Popover from '@mui/material/Popover';
import { Link, useHistory } from 'react-router-dom';
import { makeStyles, Tooltip, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { productSwitchConfig } from '../../config/productMenu';
import Infoiconprimary from '../../assets/images/infoiconprimary.svg';
import switchicon from '../../assets/images/switch_apps.svg';
import { STORE_SWITCH } from '../../config/api';
import { devLog, isDevelopment, setStoreForLocal } from '../../utils';
import http from '../../config/http';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

const useStyles = makeStyles(() => ({
  popover: {
    '&.MuiPopover-root': {
      borderRadius: '8px',
      paddingBottom: 0,
    },
  },
  adPrimaryButton: {
    fontSize: '14px!important',
    background: '#5050c8!important',
    fontWeight: '500!important',
    padding: '10px 14px 10px 14px!important',
    color: '#fff!important',
    textTransform: 'capitalize!important',
    textAlign: 'left',
    boxShadow: '0px 1px 2px rgb(16 24 40 / 5%)',
    borderRadius: '8px!important',
    width: '100%',
    fontFamily: '"Inter", Roboto, sans-serif !important',
  },
  adPrimaryButtonDisabled: {
    backgroundColor: 'rgb(147 147 147 / 10%)!important',
    color: '#989898!important',
    fontSize: '14px!important',
    fontWeight: '500!important',
    padding: '10px 14px 10px 14px!important',
    textTransform: 'capitalize!important',
    textAlign: 'left',
    boxShadow: '0px 1px 2px rgb(16 24 40 / 5%)',
    border: '1px solid rgba(254, 240, 199, 0.33)',
    borderRadius: '8px!important',
    width: '100%',
    fontFamily: '"Inter", Roboto, sans-serif !important',
  },
  storelistButton: {
    background: 'rgba(52, 64, 84, 0.31)',
    border: '1px solid rgba(254, 240, 199, 0.33)',
    boxShadow: '0px 1px 2px rgb(16 24 40 / 5%)',
    borderRadius: '8px!important',
    display: 'flex',
    padding: '10px!important',
    justifyContent: 'space-between',
    width: '100%',
    '&:hover': {
      background: '#ffffff1f',
      border: '1px solid rgb(254 240 199 / 55%)',
    },
  },
  storeIcon: {
    width: '100%',
    height: '36px',
    borderRadius: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '10px',
    '& img': {
      height: '27px',
    },
  },
}));

function ProductSwitcher() {
  const classes = useStyles();
  const history = useHistory();
  const [productMenuAnchorEl, setProductMenuAnchorEl] = useState(null);
  const realm = useSelector(({ auth }) => auth.realm ?? 'growz');
  const openProductsMenu = Boolean(productMenuAnchorEl);
  const idProductMenu = openProductsMenu ? 'simple-popover' : undefined;
  const { storeId } = useSelector(({ auth }) => auth.store);

  const handelProductSwitch = async (product) => {
    try {
      await http.post(STORE_SWITCH, { storeId, app: product });
      !isDevelopment() || setStoreForLocal(storeId);
      history.push(productSwitchConfig[product].link);
    } catch (e) {
      devLog(e);
    }
  };

  return (
    <>
      <button onClick={(e) => setProductMenuAnchorEl(e.currentTarget)} className="storeSwitch">
        <img src={productSwitchConfig[realm]?.logo} className="featureLogo" />
        <img src={switchicon} />
      </button>
      <Popover
        id={idProductMenu}
        open={openProductsMenu}
        anchorEl={productMenuAnchorEl}
        onClose={() => setProductMenuAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        className="storelist_popup features_popup"
      >
        <div
          className="cardShadowPopupsDark"
          style={{ width: '230px', borderRadius: '10px', padding: '16px 16px 16px 8px' }}
        >
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography
                variant="body2"
                style={{
                  fontSize: '16px',
                  lineHeight: '24px',
                  fontWeight: 700,
                  display: 'inline-flex',
                  justifyContent: 'space-between',
                  paddingLeft: '10px',
                }}
              >
                Switch to
              </Typography>
              <Tooltip
                title={<p style={{ padding: '0.2rem', color: '#fff', fontSize: '13px' }}> Switch between products.</p>}
                arrow
                placement="bottom-start"
              >
                <img src={Infoiconprimary} className={classes.breadcrumb_svg} />
              </Tooltip>
            </div>
            <div style={{ margin: '10px 0', overflowY: 'auto', maxHeight: '220px' }}>
              {Object.keys(productSwitchConfig).map((product) => {
                if (realm === product) {
                  return;
                }

                return (
                  <Link key={product} to="#" onClick={() => handelProductSwitch(product)} className="featurelink_single">
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                      <div className={classes.storeIcon} style={{ marginRight: '0', justifyContent: 'space-around' }}>
                        <img src={productSwitchConfig[product]?.svg} />
                        <div style={{ display: 'flex' }}>
                          <ArrowForwardRoundedIcon style={{ color: '#fff', width: '20px' }} />
                        </div>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </Popover>
    </>
  );
}

export default ProductSwitcher;
